export default __webpack_public_path__ + "static/media/Blade's Tunic of the Silent Kill.137fd6bd.jpg";